import React, { useEffect, useState } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import Select, {components} from 'react-select';
import InputNumber from './input-number';
import InputMeals from './room-meal-component'; 
import { use } from 'i18next';

const Room = ({className, roomNumber, value, onDelete, onChange}) => {
    const { t } = useTranslation();

    const [adults, setAdults] = useState(value.adults);
    const [children, setChildren] = useState(value.children);    

    const [adultMeals, setAdultMeals] = useState(() =>
            Array.from({ length: value.adults }, (_, i) => <InputMeals key={i} number={i+1} />));
    const [childrenMeals, setChildrenMeals] = useState(() => 
            Array.from({ length: value.children }, (_, i) => <InputMeals key={i} number={i+1} />));

    /*console.log(`Room(): ${roomNumber} adultMeals:`, numAdults);
    console.log(`Room(): ${roomNumber} childrenMeals:`, numChildren);
    console.log(`Room(): ${roomNumber} adults:`, adults);
    console.log(`Room(): ${roomNumber} children:`, children);
    console.log(`Room(): ${roomNumber} adultMeals:`, adultMeals.length);
    console.log(`Room(): ${roomNumber} childrenMeals:`, childrenMeals.length);
    */

    const handleSetAudults = (value) => {
        setAdults(value);
        if (value > adults ) {
            setAdultMeals((adultMeals) => [...adultMeals, ...Array.from({ length: value-adults }, 
                    (_,i) => <InputMeals key={adultMeals.length+i} number={adultMeals.length+i+1} />)]);
        } else if (value<adults) {
            setAdultMeals((adultMeals) => adultMeals.slice(0, value));
        }
    }
    const handleSetChildren = (value) => {
        setChildren(value);
        if (value > children ) {
            setChildrenMeals((childrenMeals) => [...childrenMeals, ...Array.from({ length: value-children },
                    (_,i) => <InputMeals key={childrenMeals.length+i} number={childrenMeals.length+i+1} />)]);
        } else if (value<children) {
            setChildrenMeals((childrenMeals) => childrenMeals.slice(0, value));
        }
    } 

    //removes room definition form list 
    const handleClickClose = (e) => {
        if (onDelete)   
            onDelete(roomNumber);
    }

    useEffect(() => {
        //console.log(`Room(): ${roomNumber} (adults,children):`, adults, children);
        if (onChange) {
            //TODO: additionally pack lists of meals...
            onChange(roomNumber, {adults, children});
        }
    }, [adults, children]);

    return (
        <div className={className}>
            <div className='close-handle' onClick={handleClickClose}></div>
            <label className='header'>
                <span className='label'>{t('Room')}:</span>
                <span className='value'>{roomNumber}</span>
            </label>

            <div className='field'>
                <label className='label'>{t('Adults')}:</label> 
                <InputNumber min={1} max={10} value={adults} onChange={handleSetAudults} />
            </div>

            {adultMeals}

            <div className='field'>
                <label className='label'>{t('Children')}:</label>
                <InputNumber min={0} max={10} value={children} onChange={handleSetChildren} />
            </div>

            {childrenMeals}
        </div>
    );
}

export default Room;
